export default __webpack_public_path__ + "static/footer-pattern-orange-6b6c310cd5b043f1fe07b5b6cd2b0f32.svg";